import { ButtonHTMLAttributes } from 'react';

type Variante = 'primary' | 'outline' | 'danger' | 'ghost';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante;
}

const clasesPorVariante: Record<Variante, string> = {
  primary: 'bg-terracotta hover:bg-terracotta-dark text-white',
  // border-1.5 no es una clase valida (la escala de border-width es 0/1/2/4/8) — no
  // generaba ningun CSS, asi que el boton "outline" quedaba sin borde visible en produccion.
  outline: 'bg-transparent border-[1.5px] border-wood text-wood hover:bg-bg',
  danger: 'bg-white border border-danger/40 text-danger hover:bg-danger/5',
  ghost: 'bg-transparent text-ink-muted hover:text-ink',
};

export function Button({ variante = 'primary', className = '', children, ...props }: Props) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3 text-sm font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${clasesPorVariante[variante]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
